import { createStubImplementation, affirmSingleton } from "@ardoq/stub-implementation";
const defaultImplementation = {
  logError: () => {
  },
  logWarn: () => {
  }
};
const { logError, logWarn, registerImplementation } = createStubImplementation("@ardoq/logging", defaultImplementation);
affirmSingleton("@ardoq/logging");
export {
  defaultImplementation,
  logError,
  logWarn,
  registerImplementation
};
//# sourceMappingURL=index.js.map
